<template>
    <div class="col-12 col-md-12 col-lg-10 col-xl-10">
        <div class="tit text-center">
            <h1>Questionário</h1>
            
        </div>
        <div class="row justify-content-center">
            <div class="col-12 col-md-12 col-lg-10 col-xl-10">
                <div class="text-center">
                    <h2>1. Avaliação da capacidade de assumir riscos</h2>
                </div>
                <form @submit="onSubmit">
                    <div class="item">
                        <p><strong>a.</strong> Horizonte de investimento: você pretende utilizar um percentual relevante dos seus investimentos no curto ou médio prazo?</p>
                        <div class="form-check">
                            <table class="forms">
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio"  name="HorizonteInvestimento" class="form-check-input" id="" value="1" v-model="HorizonteInvestimento">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">
                                            Sim, pretendo utilizar um percentual relevante dos meus investimentos no curto prazo (até 1 ano).
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio"  name="HorizonteInvestimento" class="form-check-input" id="" value="2" v-model="HorizonteInvestimento">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">
                                            Sim, pretendo utilizar um percentual relevante dos meus investimentos no médio prazo (de 1 a 3 anos).
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio"  name="HorizonteInvestimento" class="form-check-input" id="" value="3"  v-model="HorizonteInvestimento">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">
                                            Não tenho previsão de utilizar no curto e médio prazo.
                                        </label>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <div class="item">
                        <p><strong>b.</strong> Momento de vida: Qual das opções abaixo melhor define sua finalidade de investimento?</p>
                        <div class="form-check">
                            <table class="forms">
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio"  name="MomentoVida" class="form-check-input" id="" value="1" v-model="MomentoVida">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">Preservação de capital - O objetivo é obter um retorno suficiente para compensar a inflação, mantendo o valor real do capital constante, sem se expor a um nível de risco elevado.</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio"  name="MomentoVida" class="form-check-input" id="" value="2" v-model="MomentoVida">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">Geração de renda - O objetivo é obter um retorno constante como fonte de renda, gerando um rendimento regular, aceitando um nível de risco moderado.</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio"  name="MomentoVida" class="form-check-input" id="" value="3" v-model="MomentoVida">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">Aumento de capital - O objetivo é obter um retorno acima da inflação, resultando no aumento do capital investido, aceitando incorrer em alto nível de risco.</label>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <div class="item">
                        <p><strong>c.</strong> Distribuição dos investimentos: Qual o percentual do seu patrimônio você pretende alocar os seus investimentos na IOUU?</p>
                        <div class="form-check">
                            <table class="forms">
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio"  name="DistribuicaoInvesimento" class="form-check-input" id="" value="1" v-model="DistribuicaoInvestimento">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">Mais de 25%.</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio"  name="DistribuicaoInvesimento" class="form-check-input" id="" value="2" v-model="DistribuicaoInvestimento">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">De 10% a 25%.</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio"  name="DistribuicaoInvesimento" class="form-check-input" id="" value="3" v-model="DistribuicaoInvestimento">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">Até 10%.</label>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <div class="item">
                        <p><strong>d.</strong> Situação financeira: Qual sua renda mensal média declarada?</p>
                        <div class="form-check">
                            <table class="forms">
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio"  name="SitucaoFinanceira" class="form-check-input" id="" value="1"  v-model="SitucaoFinanceira">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">
                                            Até R$ 1.200,00.
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio"  name="SitucaoFinanceira" class="form-check-input" id="" value="2" v-model="SitucaoFinanceira">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">
                                            De R$ 1.200,00 até R$ 4.000,00.
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio"  name="SitucaoFinanceira" class="form-check-input" id="" value="3" v-model="SitucaoFinanceira">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">
                                            De R$ 4.001,00 até R$ 10.000,00.
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio"  name="SitucaoFinanceira" class="form-check-input" id="" value="4" v-model="SitucaoFinanceira">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">
                                            Acima de R$ 10.000,00.
                                        </label>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>

                     <div class="item">
                        <p><strong>e.</strong> Qual o valor total do seu patrimônio incluindo aplicações financeiras e outros bens (exceto imóvel que reside)?</p>
                        <div class="form-check">
                            <table class="forms">
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio"  name="Patrimonio" class="form-check-input" id="" value="1"  v-model="Patrimonio">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">
                                            Até R$ 50.000,00.
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio"  name="Patrimonio" class="form-check-input" id="" value="2" v-model="Patrimonio">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">
                                           De R$ 50.001,00 a R$ 200.000,00. 
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio"  name="Patrimonio" class="form-check-input" id="" value="3" v-model="Patrimonio">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">
                                            De R$ 200.001,00 a R$ 500.000,00. 
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio"  name="Patrimonio" class="form-check-input" id="" value="4" v-model="Patrimonio">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">
                                            De R$ 500.001,00 a R$ 1.000.000,00. 
                                        </label>
                                    </td>
                                </tr>
                                 <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio"  name="Patrimonio" class="form-check-input" id="" value="5" v-model="Patrimonio">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">
                                            Acima de R$ 1.000.000,00. 
                                        </label>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>

                  
                    <div class="text-center fixedOptions">
                        <form @submit="onSubmit">
                            <button class="btn btn-lg btn-primary" :disabled="verificaPreenchimento()">Próximo <img src="/static/assets/images/angle-right.svg"></button>
                        </form>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../assets/styles/iouu/_mixins.scss';
    
    @include sm {
        .steps .form-container .tit {
            margin-top: 0;
        }
    }
</style>


<script>
    /* eslint-disable */
   export default {
  data() {
    const FormularioCapacidade = this.suitability.FormularioCapacidade
    return {
      HorizonteInvestimento: FormularioCapacidade ? FormularioCapacidade.HorizonteInvestimento : null,
      MomentoVida: FormularioCapacidade ? FormularioCapacidade.MomentoVida : null,
      DistribuicaoInvestimento: FormularioCapacidade ? FormularioCapacidade.DistribuicaoInvestimento : null,
      SitucaoFinanceira: FormularioCapacidade ? FormularioCapacidade.SitucaoFinanceira : null,
      Patrimonio: FormularioCapacidade ? FormularioCapacidade.Patrimonio : null,
    }
  },
  props: {
    suitability: {required: true, type: Object}
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()

      this.$emit('on-submit', {
        FormularioCapacidade: {
            HorizonteInvestimento: this.HorizonteInvestimento,
            MomentoVida: this.MomentoVida,
            DistribuicaoInvestimento: this.DistribuicaoInvestimento,
            SitucaoFinanceira: this.SitucaoFinanceira,
            Patrimonio: this.Patrimonio
        }
      })
    },
    verificaPreenchimento(){
     console.log("verificaPreenchimento");
     return this.HorizonteInvestimento == null || this.MomentoVida == null || this.DistribuicaoInvestimento == null || this.SitucaoFinanceira == null || this.Patrimonio == null;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/InformationSuitability/InicioQuestionario.vue